<template>
  <div class="baseinfo-table">
    <div class="down">
      <ul v-if="this.$route.query.projectId !== '86-518045-001'">
        <li class="radius-top-left">
          <span>
            <span class="fontweight6">项目名称</span>
          </span>
        </li>
        <li>
          <span>
            <span>{{downData.projectName}}</span>
          </span>
        </li>
        <li>
          <span>
            <span class="fontweight6">项目地址</span>
          </span>
        </li>
        <li class="radius-top-right">
          <span>
            <span>{{downData.locationStr}}</span>
          </span>
        </li>
      </ul>
      <ul>
        <li>
          <span>
            <span class="fontweight6">储能功率（kW）</span>
          </span>
        </li>
        <li>
          <span>
            <span>{{downData.energyStoragePower}}</span>
          </span>
        </li>
        <li>
          <span>
            <span class="fontweight6">储能容量（kWh）</span>
          </span>
        </li>
        <li>
          <span>
            <span>{{downData.energyStorageCapacity}}</span>
          </span>
        </li>
      </ul>
      <ul v-if="this.$route.query.projectId !== '86-518045-001'">
        <li>
          <span>
            <span class="fontweight6">系统类型</span>
          </span>
        </li>
        <li>
          <span>
            <span>{{downData.systemType}}</span>
          </span>
        </li>
        <li>
          <span>
            <span class="fontweight6">储能产品类型</span>
          </span>
        </li>
        <li>
          <span>
            <span>{{downData.energyStorageProductType}}</span>
          </span>
        </li>
      </ul>
      <ul>
        <li class="radius-bottom-left">
          <span>
            <span class="fontweight6">储能产品数量</span>
          </span>
        </li>
        <li>
          <span>
            <span>{{downData.productNum}}</span>
          </span>
        </li>
        <li>
          <span>
            <span class="fontweight6">项目并网点数量</span>
          </span>
        </li>
        <li class="radius-bottom-right">
          <span>
            <span>{{downData.parallelBranchNum}}</span>
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import API from '@/api/svolt/project';
  export default {
    props: {
    },
    data() {
      return {
        downData: []
      };
    },
    methods: {
      init() {},
      searchProjectInfoForMain() {
        API.searchProjectInfoForMain({
          projectId: this.$route.query.projectId
        }).then(res => {
          if (res.data.code == 200) {
            this.downData = res.data.data
          }
        })
      }
    },
    created() {
      this.searchProjectInfoForMain()
    },
    mounted() {}
  };
</script>

<style lang="scss" scoped>
  .baseinfo-table {
    min-height: 160px;
    width: 1000px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: calc(100% - 188px);
    z-index: 100;

    .radius-top-left {
      border-top-left-radius: 5px;
    }

    .radius-top-right {
      border-top-right-radius: 5px;
    }

    .radius-bottom-left {
      border-bottom-left-radius: 5px;
    }

    .radius-bottom-right {
      border-bottom-right-radius: 5px;
    }

    .fontweight6 {
      font-weight: 600 !important;
      width: 150px;
      text-align: left;
      margin-left: 40px !important;
    }

    .down {
      border: 1px solid #7FA0EE;
      border-radius: 6px;
      margin-top: 16px;

      ul {
        border-bottom: 1px solid #7FA0EE;
        display: flex;
        height: 40px;
        width: 100%;
        box-sizing: border-box;

        li {
          background-color: #F1F6FF;
          flex: 1;
          text-align: center;
          line-height: 40px;
          position: relative;

          // border-right: 1px solid #144E9E;
          &:after {
            content: '';
            position: absolute;
            left: auto;
            top: auto;
            bottom: 7px;
            right: 0;
            height: 52%;
            width: 1Px;
            background-color: #7FA0EE;
          }

          box-sizing: border-box;

          &:nth-last-child(1) {
            &:after {
              content: '';
              position: absolute;
              left: auto;
              top: auto;
              bottom: 7px;
              right: 0;
              height: 52%;
              width: 0px;
              background-color: #7FA0EE;
            }
          }

          span:nth-child(1) {
            display: inline-block;
            color: #3F485B;
            line-height: 16px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            margin: 0px 2px;
          }

          span:nth-child(2) {
            display: inline-block;
            position: relative;
            font-family: DINBold, DINAlternate;
            font-weight: 600;
            color: #76DEFC;
            margin: 0px 2px;
            top: 2px;
            font-size: 18px;
            font-weight: bold;
            color: #0F2C63;
          }
        }

        &:nth-last-child(1) {
          border-bottom: 0px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/svolt/project/components/nanwang/baseinfo-table.vue